import { Button, Dropdown, type MenuProps } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import type { ERPColumnDef } from './ERPTable';

export type ActionMenuItems<T> =
  | MenuProps['items']
  | ((row: T) => MenuProps['items']);

export interface CreateActionColumnOptions<T> {
  items: ActionMenuItems<T>;
  onAction?: (key: string, row: T) => void;
  width?: number;
  icon?: React.ReactNode;
  /** Prefix cho data-testid (e.g. "product"). Final testid: {prefix}-action-{id}. */
  testIdPrefix?: string;
  /** Accessor for row's business id (default _id/id). */
  testIdAccessor?: (row: T) => string | number | undefined;
}

export function createActionColumn<T>(opts: CreateActionColumnOptions<T>): ERPColumnDef<T> {
  return {
    key: '_actions',
    title: '',
    width: opts.width ?? 52,
    render: (_: unknown, row: T) => {
      const menuItems = typeof opts.items === 'function' ? opts.items(row) : opts.items;
      const id =
        opts.testIdAccessor?.(row) ??
        (row as { _id?: string | number; id?: string | number })._id ??
        (row as { id?: string | number }).id;
      const testId = opts.testIdPrefix && id != null
        ? `${opts.testIdPrefix}-action-${id}`
        : undefined;
      return (
        <Dropdown
          trigger={['click']}
          menu={{
            items: menuItems,
            onClick: ({ key }) => opts.onAction?.(String(key), row),
          }}
        >
          <Button
            size="small"
            type="text"
            icon={opts.icon ?? <MoreOutlined />}
            aria-label="Thao tác"
            data-testid={testId}
          />
        </Dropdown>
      );
    },
  };
}
